import { useEffect, useState } from "react";
import { ConfusionZone, FalloutCharacter, FalloutCharacterStatus, FalloutConfusionZonesPrompt } from "../Data/Response";

interface ControlZoneModalArgs {
    prompt: FalloutConfusionZonesPrompt;
    returnControlZones: (zones: ConfusionZone[]) => void;
    crewCharacters: FalloutCharacter[];
}

const ControlZoneModal: React.FC<ControlZoneModalArgs> = args => {
    const [controlZones, SetControlZones] = useState<ConfusionZone[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const completedIds = controlZones.map(z => z.CharacterId);
    const missingId = args.prompt.characterIds.find(id => !completedIds.includes(id));

    useEffect(() => {
        if (isLoading) {
            return;
        }
        const missingId = args.prompt.characterIds.find(id => !completedIds.includes(id));
        if (missingId) {
            return;
        }
        setIsLoading(true);
        args.returnControlZones(controlZones);
    }, [controlZones]);

    if (isLoading) {
        return <div>Sending to Server...</div>
    }

    if (errorMessage || !missingId) {
        return <div>
            <p>Error: {errorMessage ?? "Unknown error processing"}</p>
        </div>
    }

    return <div>
        <h1>Tell server the Control Zone for:</h1>
        <SetControlZoneView
            characterOptions={args.crewCharacters.filter(c => c.id !== missingId && c.state.status === "active")}
            completeHandler={ids => {
                SetControlZones(prev => {
                    return [
                        ...prev,
                        {
                            CharacterId: missingId,
                            ConfusedCharacterIds: ids
                        }
                    ]
                })
            }}
        />
    </div>
}


interface SetControlZoneArgs {
    characterOptions: FalloutCharacter[];
    completeHandler: (affectedCharacterIds: string[]) => void;
}

const SetControlZoneView: React.FC<SetControlZoneArgs> = args => {
    const [affectedCharacterIds, setAffectedCharacterIds] = useState<string[]>([]);

    return <div>
        <ul>
            {args.characterOptions.map(c => {
                return <li>
                    <input
                        type="checkbox"
                        checked={affectedCharacterIds.includes(c.id)}
                        onChange={e => {
                            if (
                                e.target.checked &&
                                !affectedCharacterIds.includes(c.id)
                            ) {
                                setAffectedCharacterIds(prev => [...prev, c.id]);
                                return;
                            }
                            setAffectedCharacterIds(prev => prev.filter(id => id !== c.id));
                        }}
                    />{c.name} : {c.id}
                </li>
            })}
        </ul>
        <button
            onClick={e => {
                args.completeHandler(affectedCharacterIds);
            }}
        >Complete</button>
    </div>
}

export default ControlZoneModal;